import repository from '@/repositories/repository'

export default baseUrl => {
    baseUrl = `${baseUrl}/usuario-perfil`

    return {
        edit: id => {
            return repository.get(`${baseUrl}/${id}`)
        },

        update: (id, params) => {
            return repository.put(`${baseUrl}/${id}`, params)
        },
    }
}